module.exports = __webpack_public_path__ + "img/img14.a00fd572.png";